/**
 * Checks if the previous and next properties are equal.
 *
 * @param {any} prevProp - The previous property to compare.
 * @param {any} nextProp - The next property to compare.
 *
 * @returns {boolean} - Returns true if the previous and next properties are equal, false otherwise.
 *
 * The function first checks if the previous property is the same as the next property, or if the next property is null or NaN. If so, it returns true.
 *
 * It then checks if the next property is an object (and not an array). If the 'code' or 'description' properties of the previous and next properties are the same, it returns true.
 *
 * The function then checks if the next property is an array. It handles various cases:
 *  - If the previous property is not an array, it returns false.
 *  - If the lengths of the previous and next properties do not match, it returns false.
 *  - If the contents of the previous and next properties have changed, it returns false.
 *  - If no differences are found in the array contents, it returns true.
 *
 * If none of the above conditions are met, it returns false.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return arePropsEqual;
    }
});
function arePropsEqual(prevProp, nextProp) {
    // Simplify the first condition
    if (prevProp === nextProp || nextProp == null || Number.isNaN(nextProp)) {
        return true;
    }
    // Check Objects
    if (typeof nextProp === "object" && !Array.isArray(nextProp)) {
        if ((prevProp === null || prevProp === void 0 ? void 0 : prevProp.code) === nextProp.code || (prevProp === null || prevProp === void 0 ? void 0 : prevProp.description) === nextProp.description) {
            return true;
        }
    }
    // Check Arrays
    if (Array.isArray(nextProp)) {
        // From null to array
        if (!Array.isArray(prevProp)) {
            return false;
        }
        // Lengths don't match
        if (nextProp.length !== prevProp.length) {
            return false;
        }
        // TODO: temporary
        // Lengths match but contents have changed
        if (JSON.stringify(prevProp) !== JSON.stringify(nextProp)) {
            return false;
        }
        // No differences found in array contents
        return true;
    }
    return false;
}
